import { render, staticRenderFns } from "./UnitaMobileDeletedDialog.vue?vue&type=template&id=1bce5dd7&"
import script from "./UnitaMobileDeletedDialog.vue?vue&type=script&lang=js&"
export * from "./UnitaMobileDeletedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SprayerManager_WebSite/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
